<!-- 活动-立即报名-信息 -->
<template>
	<div class="wrap">

		<div class="header-wrap" ref="header-wrap">
			<div class="header">
				<img src="../assets/return.png" class="return-img" @click="$router.back()">
				<p class="header-title">完善信息</p>
			</div>
		</div>

		<div class="padding-box">

			<div class="box">
				<div class="row">
					<span class="row-label">联系人</span>
					<div class="row-sidebar">
						<input class="row-input" type="" placeholder="请输入联系人姓名" name="" id="" value="" />
					</div>
				</div>
				<div class="row">
					<span class="row-label">手机号</span>
					<div class="row-sidebar">
						<input class="row-input" type="" placeholder="请输入手机号" name="" id="" value="" />
					</div>
				</div>
				<div class="row">
					<span class="row-label">手机验证码</span>
					<div class="row-sidebar">
						<input class="row-input" type="" placeholder="请输入验证码" name="" id="" value="" />
					</div>
					<button type="button" class="get-code">获取验证码</button>
				</div>
				<div class="row">
					<span class="row-label">公司邮箱</span>
					<div class="row-sidebar">
						<input class="row-input" type="" placeholder="请输入邮箱" name="" id="" value="" />
					</div>
				</div>
				<div class="row">
					<span class="row-label">报名人数</span>
					<div class="row-sidebar">
						<input class="row-input" type="" placeholder="请输入报名人数" name="" id="" value="" />
					</div>
				</div>
				<div class="row-start">
					<span class="symobl">*</span>
					<p class="row-column">
						<span>1人：100/人</span>
						<span>2人：90/人</span>
						<span>3人及以上：80/人</span>
					</p>
				</div>
			</div>

			<div class="box">
				<p class="box-label">选择支付方式</p>
				<ul class="pay-list">
					<li>
						<p class="pay-sidebar">
							<img src="../assets/type-6.png" class="pay-icon">支付宝支付
						</p>
						<img src="../assets/circle-active.png" class="circle-img">
					</li>
					<li>
						<p class="pay-sidebar">
							<img src="../assets/type-5.png" class="pay-icon">微信支付
						</p>
						<img src="../assets/circle.png" class="circle-img">
					</li>
				</ul>
			</div>

		</div>

		<div class="footer">
			<div class="footer-wrap">
				<p class="footer-price">
					总计
					<span>
						¥279
					</span>
				</p>
				<button type="button" class="footer-btn">立即支付</button>
			</div>
		</div>


	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				is_like: 1
			};
		},
		mounted() {

		},
		methods: {

		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		min-height: 100vh;
		background-color: #F4F4F4;
		display: flex;
		flex-direction: column;
		padding: 44px 0 83px;
		box-sizing: border-box;
	}

	/* 头部样式 */
	.header-wrap {
		width: 100%;
		height: 44px;
		display: flex;
		flex-direction: column;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 500;
		background-color: #FFFFFF;
	}

	.header-wrap-tab-list-none {
		height: 80px;
		padding-bottom: 10px;
	}

	.header {
		width: 100%;
		height: 44px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #FFFFFF;
		z-index: 999;
		padding: 0 15px;
		position: relative;
		box-sizing: border-box;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		color: #333333;
		font-size: 18px;
		font-weight: 500;
	}

	.footer {
		width: 100%;
		height: 83px;
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 999;
		background-color: #FFFFFF;
		display: flex;
		justify-content: center;
		align-items: flex-start;
		padding: 6px 15px 0;
		box-sizing: border-box;
	}

	.footer-wrap {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}


	.footer-btn {
		width: 165px;
		height: 40px;
		line-height: 40px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 18px;
		font-weight: bold;
		color: #FFFFFF;
		background-color: #2A63F3;
		border-radius: 50px;
	}

	.footer-price {
		font-size: 14px;
		color: #333333;
	}

	.footer-price>span {
		font-size: 22px;
		color: #2A63F3;
		font-weight: bold;
		margin-left: 8px;
	}

	.padding-box {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 10px 15px;
		box-sizing: border-box;
	}

	.box {
		width: 100%;
		display: flex;
		flex-direction: column;
		background-color: #FFFFFF;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
		border-radius: 12px;
		padding: 16px 15px;
		box-sizing: border-box;
		margin-bottom: 12px;
	}

	.row {
		width: 100%;
		height: 40px;
		line-height: 40px;
		padding: 0 14px;
		box-sizing: border-box;
		border-radius: 4px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 12px;
		background-color: #F4F4F4;
	}

	.row-label {
		width: 85px;
		color: #222222;
		font-size: 13px;
	}

	.row-sidebar {
		flex: 1;
		display: flex;
		align-items: center;
	}

	.row-input {
		width: 100%;
		font-size: 13px;
		color: #333333;
	}

	.row-input::placeholder {
		color: #999999;
	}

	.get-code {
		color: #2A63F3;
		font-size: 13px;
	}

	.row-start {
		width: 100%;
		display: flex;
		align-items: flex-start;
	}

	.symobl {
		font-size: 10px;
		color: #FF0000;
		margin-right: 2px;
	}

	.row-column {
		flex: 1;
		display: flex;
		flex-direction: column;
		color: #888888;
		font-size: 10px;
	}

	.box-label {
		width: 100%;
		font-size: 14px;
		color: #333333;
		font-weight: bold;
		margin-bottom: 20px;
	}

	.pay-list {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.pay-list>li {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 30px;
	}

	.pay-list>li:last-child {
		margin-bottom: 0;
	}

	.pay-sidebar {
		display: flex;
		align-items: center;
		font-size: 14px;
		color: #333333;
	}

	.pay-icon {
		width: 22px;
		margin-right: 16px;
	}

	.circle-img {
		width: 20px;
	}
</style>
